// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 2.1.0 (commit 6981f48b4bc1a71c8dd9bdfe5a2c343f6370243d).

/* eslint-disable */
/* tslint:disable */
import {
  DbConnectionBuilder as __DbConnectionBuilder,
  DbConnectionImpl as __DbConnectionImpl,
  SubscriptionBuilderImpl as __SubscriptionBuilderImpl,
  TypeBuilder as __TypeBuilder,
  Uuid as __Uuid,
  convertToAccessorMap as __convertToAccessorMap,
  makeQueryBuilder as __makeQueryBuilder,
  procedureSchema as __procedureSchema,
  procedures as __procedures,
  reducerSchema as __reducerSchema,
  reducers as __reducers,
  schema as __schema,
  t as __t,
  table as __table,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type DbConnectionConfig as __DbConnectionConfig,
  type ErrorContextInterface as __ErrorContextInterface,
  type Event as __Event,
  type EventContextInterface as __EventContextInterface,
  type Infer as __Infer,
  type QueryBuilder as __QueryBuilder,
  type ReducerEventContextInterface as __ReducerEventContextInterface,
  type RemoteModule as __RemoteModule,
  type SubscriptionEventContextInterface as __SubscriptionEventContextInterface,
  type SubscriptionHandleImpl as __SubscriptionHandleImpl,
} from "spacetimedb";

// Import all reducer arg schemas
import AdminAddOrgMemberReducer from "./admin_add_org_member_reducer";
import AdminAddRepoConnectionReducer from "./admin_add_repo_connection_reducer";
import AdminAddRetroNoteReducer from "./admin_add_retro_note_reducer";
import AdminAddThreadParticipantReducer from "./admin_add_thread_participant_reducer";
import AdminAddWorkspaceMemberReducer from "./admin_add_workspace_member_reducer";
import AdminAppendAgentMessageChunkReducer from "./admin_append_agent_message_chunk_reducer";
import AdminAttachMessageEvidenceReducer from "./admin_attach_message_evidence_reducer";
import AdminAttachOutcomeTagReducer from "./admin_attach_outcome_tag_reducer";
import AdminAttachReceiptNarrationReducer from "./admin_attach_receipt_narration_reducer";
import AdminAttachTaskTagReducer from "./admin_attach_task_tag_reducer";
import AdminCloseRunnerSessionReducer from "./admin_close_runner_session_reducer";
import AdminCloseWorkspaceTabReducer from "./admin_close_workspace_tab_reducer";
import AdminCompleteAgentMessageReducer from "./admin_complete_agent_message_reducer";
import AdminCompletePendingRouteReducer from "./admin_complete_pending_route_reducer";
import AdminCompletePendingTurnReducer from "./admin_complete_pending_turn_reducer";
import AdminCreateAgendaReducer from "./admin_create_agenda_reducer";
import AdminCreateGateReducer from "./admin_create_gate_reducer";
import AdminCreateOrgReducer from "./admin_create_org_reducer";
import AdminCreateOrgInviteReducer from "./admin_create_org_invite_reducer";
import AdminCreatePendingCommitReducer from "./admin_create_pending_commit_reducer";
import AdminCreatePersonaCandidateReducer from "./admin_create_persona_candidate_reducer";
import AdminCreateReceiptReducer from "./admin_create_receipt_reducer";
import AdminCreateRoadReducer from "./admin_create_road_reducer";
import AdminCreateShadowRunReducer from "./admin_create_shadow_run_reducer";
import AdminCreateStepReducer from "./admin_create_step_reducer";
import AdminCreateTeamRecipeReducer from "./admin_create_team_recipe_reducer";
import AdminCreateThreadReducer from "./admin_create_thread_reducer";
import AdminCreateUserAgentReducer from "./admin_create_user_agent_reducer";
import AdminCreateUserWatcherReducer from "./admin_create_user_watcher_reducer";
import AdminCreateWorkspaceReducer from "./admin_create_workspace_reducer";
import AdminDeleteAgendaReducer from "./admin_delete_agenda_reducer";
import AdminDeleteMessageReducer from "./admin_delete_message_reducer";
import AdminDeletePersonaCandidateReducer from "./admin_delete_persona_candidate_reducer";
import AdminDeletePersonaContractReducer from "./admin_delete_persona_contract_reducer";
import AdminDeleteRoadReducer from "./admin_delete_road_reducer";
import AdminDeleteStepReducer from "./admin_delete_step_reducer";
import AdminDeleteTeamRecipeReducer from "./admin_delete_team_recipe_reducer";
import AdminDeleteUserAgentReducer from "./admin_delete_user_agent_reducer";
import AdminDeleteWorkspaceReducer from "./admin_delete_workspace_reducer";
import AdminEnsureUserPersonalOrgReducer from "./admin_ensure_user_personal_org_reducer";
import AdminFailPendingTurnReducer from "./admin_fail_pending_turn_reducer";
import AdminForkTeamRecipeReducer from "./admin_fork_team_recipe_reducer";
import AdminInsertFollowUpRouteReducer from "./admin_insert_follow_up_route_reducer";
import AdminLockPendingRouteReducer from "./admin_lock_pending_route_reducer";
import AdminLockPendingTurnReducer from "./admin_lock_pending_turn_reducer";
import AdminMarkModelReleaseQueuedReducer from "./admin_mark_model_release_queued_reducer";
import AdminMarkOrgInviteAcceptedReducer from "./admin_mark_org_invite_accepted_reducer";
import AdminOpenRunnerSessionReducer from "./admin_open_runner_session_reducer";
import AdminOpenWorkspaceTabReducer from "./admin_open_workspace_tab_reducer";
import AdminPostAgentMessageReducer from "./admin_post_agent_message_reducer";
import AdminPostMessageReducer from "./admin_post_message_reducer";
import AdminPostSystemMessageReducer from "./admin_post_system_message_reducer";
import AdminPostThreadMessageReducer from "./admin_post_thread_message_reducer";
import AdminPublishPersonaCardSeedReducer from "./admin_publish_persona_card_seed_reducer";
import AdminRecordChatUsageReducer from "./admin_record_chat_usage_reducer";
import AdminRecordCuratedEntryReducer from "./admin_record_curated_entry_reducer";
import AdminRecordDecisionReducer from "./admin_record_decision_reducer";
import AdminRecordDigestSentReducer from "./admin_record_digest_sent_reducer";
import AdminRecordDriftAlertReducer from "./admin_record_drift_alert_reducer";
import AdminRecordFindingReducer from "./admin_record_finding_reducer";
import AdminRecordModelReleaseReducer from "./admin_record_model_release_reducer";
import AdminRecordNewsItemReducer from "./admin_record_news_item_reducer";
import AdminRecordRecipeUseReducer from "./admin_record_recipe_use_reducer";
import AdminRecordRemoteEnvUsageReducer from "./admin_record_remote_env_usage_reducer";
import AdminRecordResendUsageReducer from "./admin_record_resend_usage_reducer";
import AdminRecordScoreReducer from "./admin_record_score_reducer";
import AdminRecordTracePointReducer from "./admin_record_trace_point_reducer";
import AdminRecordTurnUsageReducer from "./admin_record_turn_usage_reducer";
import AdminRecordWatcherFireReducer from "./admin_record_watcher_fire_reducer";
import AdminRecordWorkspaceHeartbeatReducer from "./admin_record_workspace_heartbeat_reducer";
import AdminRegisterUserReducer from "./admin_register_user_reducer";
import AdminRemoveRepoConnectionReducer from "./admin_remove_repo_connection_reducer";
import AdminRemoveWorkspaceMemberReducer from "./admin_remove_workspace_member_reducer";
import AdminRenameOrgReducer from "./admin_rename_org_reducer";
import AdminRenameRoadReducer from "./admin_rename_road_reducer";
import AdminRenameWorkspaceReducer from "./admin_rename_workspace_reducer";
import AdminResolveDriftAlertReducer from "./admin_resolve_drift_alert_reducer";
import AdminRevokeCicdWebhookSecretReducer from "./admin_revoke_cicd_webhook_secret_reducer";
import AdminRevokeProviderKeyReducer from "./admin_revoke_provider_key_reducer";
import AdminRevokeWorkspaceProviderKeyReducer from "./admin_revoke_workspace_provider_key_reducer";
import AdminRouteToSeatReducer from "./admin_route_to_seat_reducer";
import AdminRunnerHeartbeatReducer from "./admin_runner_heartbeat_reducer";
import AdminSeedStarterRecipesReducer from "./admin_seed_starter_recipes_reducer";
import AdminSeedWorkspaceVelaReducer from "./admin_seed_workspace_vela_reducer";
import AdminSetAgentAvatarUrlReducer from "./admin_set_agent_avatar_url_reducer";
import AdminSetAgentModelReducer from "./admin_set_agent_model_reducer";
import AdminSetAgentMutedReducer from "./admin_set_agent_muted_reducer";
import AdminSetAgentStatusReducer from "./admin_set_agent_status_reducer";
import AdminSetAgentTriggerReducer from "./admin_set_agent_trigger_reducer";
import AdminSetCicdWebhookSecretReducer from "./admin_set_cicd_webhook_secret_reducer";
import AdminSetGateStatusReducer from "./admin_set_gate_status_reducer";
import AdminSetOrgLimitsReducer from "./admin_set_org_limits_reducer";
import AdminSetPendingCommitStatusReducer from "./admin_set_pending_commit_status_reducer";
import AdminSetProviderKeyReducer from "./admin_set_provider_key_reducer";
import AdminSetRepoCommitAuthorReducer from "./admin_set_repo_commit_author_reducer";
import AdminSetStepOrderReducer from "./admin_set_step_order_reducer";
import AdminSetStepStatusReducer from "./admin_set_step_status_reducer";
import AdminSetUserRoleReducer from "./admin_set_user_role_reducer";
import AdminSetWorkspaceAutonomyReducer from "./admin_set_workspace_autonomy_reducer";
import AdminSetWorkspaceDigestHourReducer from "./admin_set_workspace_digest_hour_reducer";
import AdminSetWorkspaceEscalationEmailReducer from "./admin_set_workspace_escalation_email_reducer";
import AdminSetWorkspaceModelAccessReducer from "./admin_set_workspace_model_access_reducer";
import AdminSetWorkspaceProviderKeyReducer from "./admin_set_workspace_provider_key_reducer";
import AdminSetWorkspaceSandboxReducer from "./admin_set_workspace_sandbox_reducer";
import AdminSupersedeDecisionReducer from "./admin_supersede_decision_reducer";
import AdminSupersedeReceiptReducer from "./admin_supersede_receipt_reducer";
import AdminUpdateShadowRunStatusReducer from "./admin_update_shadow_run_status_reducer";
import AdminUpsertCicdResultReducer from "./admin_upsert_cicd_result_reducer";
import AdminUpsertHarnessScoreReducer from "./admin_upsert_harness_score_reducer";
import AdminUpsertPersonaContractReducer from "./admin_upsert_persona_contract_reducer";
import AdminUpsertPersonaScoreRollupReducer from "./admin_upsert_persona_score_rollup_reducer";
import AdminUpsertRecipeScorecardReducer from "./admin_upsert_recipe_scorecard_reducer";
import AdminUpsertUserScoreRollupReducer from "./admin_upsert_user_score_rollup_reducer";
import AdminWriteWorkspaceMemoryReducer from "./admin_write_workspace_memory_reducer";
import BootstrapAdminReducer from "./bootstrap_admin_reducer";

// Import all procedure arg schemas

// Import all table schema definitions
import AdminRegistryRow from "./admin_registry_table";
import AgendaRow from "./agenda_table";
import AgentRow from "./agent_table";
import AgentPresenceRow from "./agent_presence_table";
import ChatUsageRow from "./chat_usage_table";
import CicdResultRow from "./cicd_result_table";
import CicdWebhookSecretRow from "./cicd_webhook_secret_table";
import DecisionRow from "./decision_table";
import DigestSentRow from "./digest_sent_table";
import DriftAlertRow from "./drift_alert_table";
import EventRow from "./event_table";
import FindingRow from "./finding_table";
import GateRow from "./gate_table";
import HarnessScoreRow from "./harness_score_table";
import LedgerEntryCuratedRow from "./ledger_entry_curated_table";
import MessageRow from "./message_table";
import MessageAttachmentRow from "./message_attachment_table";
import MessageChunkRow from "./message_chunk_table";
import MessageMentionRow from "./message_mention_table";
import MessageStatusRow from "./message_status_table";
import ModelReleaseRow from "./model_release_table";
import ModuleHeartbeatRow from "./module_heartbeat_table";
import NewsItemRow from "./news_item_table";
import OrgRow from "./org_table";
import OrgInviteRow from "./org_invite_table";
import OrgLimitsRow from "./org_limits_table";
import OrgMembershipRow from "./org_membership_table";
import OutcomeTagRow from "./outcome_tag_table";
import PendingCommitRow from "./pending_commit_table";
import PendingRouteRow from "./pending_route_table";
import PendingTurnRow from "./pending_turn_table";
import PersonaCandidateRow from "./persona_candidate_table";
import PersonaCardSeedRow from "./persona_card_seed_table";
import PersonaContractRow from "./persona_contract_table";
import PersonaScoreRollupRow from "./persona_score_rollup_table";
import ProviderKeyRow from "./provider_key_table";
import ReceiptRow from "./receipt_table";
import ReceiptNarrationRow from "./receipt_narration_table";
import RecipeScorecardRow from "./recipe_scorecard_table";
import RecipeUseRow from "./recipe_use_table";
import RemoteEnvUsageRow from "./remote_env_usage_table";
import RepoCommitAuthorRow from "./repo_commit_author_table";
import RepoConnectionRow from "./repo_connection_table";
import ResendUsageRow from "./resend_usage_table";
import RoadRow from "./road_table";
import RunnerSessionRow from "./runner_session_table";
import ScoreRow from "./score_table";
import ShadowRunRow from "./shadow_run_table";
import StepRow from "./step_table";
import StripeEventRow from "./stripe_event_table";
import SubscriptionRow from "./subscription_table";
import TaskTagRow from "./task_tag_table";
import TeamRecipeRow from "./team_recipe_table";
import TeamRecipeSeatRow from "./team_recipe_seat_table";
import ThreadRow from "./thread_table";
import ThreadMessageRow from "./thread_message_table";
import ThreadParticipantRow from "./thread_participant_table";
import TracePointRow from "./trace_point_table";
import TurnUsageRow from "./turn_usage_table";
import UserCredentialRow from "./user_credential_table";
import UserProfileRow from "./user_profile_table";
import UserRoleRow from "./user_role_table";
import UserScoreRollupRow from "./user_score_rollup_table";
import WatcherFireRow from "./watcher_fire_table";
import WorkspaceRow from "./workspace_table";
import WorkspaceMemberRow from "./workspace_member_table";
import WorkspaceMemoryRow from "./workspace_memory_table";
import WorkspaceModelAccessRow from "./workspace_model_access_table";
import WorkspaceProviderKeyRow from "./workspace_provider_key_table";
import WorkspaceTabRow from "./workspace_tab_table";

/** Type-only namespace exports for generated type groups. */

/** The schema information for all tables in this module. This is defined the same was as the tables would have been defined in the server. */
const tablesSchema = __schema({
  admin_registry: __table({
    name: 'admin_registry',
    indexes: [
      { accessor: 'identity', name: 'admin_registry_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'admin_registry_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, AdminRegistryRow),
  agenda: __table({
    name: 'agenda',
    indexes: [
      { accessor: 'agenda_id', name: 'agenda_agenda_id_idx_btree', algorithm: 'btree', columns: [
        'agendaId',
      ] },
    ],
    constraints: [
      { name: 'agenda_agenda_id_key', constraint: 'unique', columns: ['agendaId'] },
    ],
  }, AgendaRow),
  agent: __table({
    name: 'agent',
    indexes: [
      { accessor: 'agent_id', name: 'agent_agent_id_idx_btree', algorithm: 'btree', columns: [
        'agentId',
      ] },
    ],
    constraints: [
      { name: 'agent_agent_id_key', constraint: 'unique', columns: ['agentId'] },
    ],
  }, AgentRow),
  agent_presence: __table({
    name: 'agent_presence',
    indexes: [
      { accessor: 'agent_id', name: 'agent_presence_agent_id_idx_btree', algorithm: 'btree', columns: [
        'agentId',
      ] },
    ],
    constraints: [
      { name: 'agent_presence_agent_id_key', constraint: 'unique', columns: ['agentId'] },
    ],
  }, AgentPresenceRow),
  chat_usage: __table({
    name: 'chat_usage',
    indexes: [
      { accessor: 'chat_usage_id', name: 'chat_usage_chat_usage_id_idx_btree', algorithm: 'btree', columns: [
        'chatUsageId',
      ] },
    ],
    constraints: [
      { name: 'chat_usage_chat_usage_id_key', constraint: 'unique', columns: ['chatUsageId'] },
    ],
  }, ChatUsageRow),
  cicd_result: __table({
    name: 'cicd_result',
    indexes: [
      { accessor: 'result_id', name: 'cicd_result_result_id_idx_btree', algorithm: 'btree', columns: [
        'resultId',
      ] },
    ],
    constraints: [
      { name: 'cicd_result_result_id_key', constraint: 'unique', columns: ['resultId'] },
    ],
  }, CicdResultRow),
  cicd_webhook_secret: __table({
    name: 'cicd_webhook_secret',
    indexes: [
      { accessor: 'workspace_id', name: 'cicd_webhook_secret_workspace_id_idx_btree', algorithm: 'btree', columns: [
        'workspaceId',
      ] },
    ],
    constraints: [
      { name: 'cicd_webhook_secret_workspace_id_key', constraint: 'unique', columns: ['workspaceId'] },
    ],
  }, CicdWebhookSecretRow),
  decision: __table({
    name: 'decision',
    indexes: [
      { accessor: 'decision_id', name: 'decision_decision_id_idx_btree', algorithm: 'btree', columns: [
        'decisionId',
      ] },
    ],
    constraints: [
      { name: 'decision_decision_id_key', constraint: 'unique', columns: ['decisionId'] },
    ],
  }, DecisionRow),
  digest_sent: __table({
    name: 'digest_sent',
    indexes: [
      { accessor: 'digest_sent_id', name: 'digest_sent_digest_sent_id_idx_btree', algorithm: 'btree', columns: [
        'digestSentId',
      ] },
    ],
    constraints: [
      { name: 'digest_sent_digest_sent_id_key', constraint: 'unique', columns: ['digestSentId'] },
    ],
  }, DigestSentRow),
  drift_alert: __table({
    name: 'drift_alert',
    indexes: [
      { accessor: 'alert_id', name: 'drift_alert_alert_id_idx_btree', algorithm: 'btree', columns: [
        'alertId',
      ] },
    ],
    constraints: [
      { name: 'drift_alert_alert_id_key', constraint: 'unique', columns: ['alertId'] },
    ],
  }, DriftAlertRow),
  event: __table({
    name: 'event',
    indexes: [
      { accessor: 'event_id', name: 'event_event_id_idx_btree', algorithm: 'btree', columns: [
        'eventId',
      ] },
    ],
    constraints: [
      { name: 'event_event_id_key', constraint: 'unique', columns: ['eventId'] },
    ],
  }, EventRow),
  finding: __table({
    name: 'finding',
    indexes: [
      { accessor: 'finding_id', name: 'finding_finding_id_idx_btree', algorithm: 'btree', columns: [
        'findingId',
      ] },
    ],
    constraints: [
      { name: 'finding_finding_id_key', constraint: 'unique', columns: ['findingId'] },
    ],
  }, FindingRow),
  gate: __table({
    name: 'gate',
    indexes: [
      { accessor: 'gate_id', name: 'gate_gate_id_idx_btree', algorithm: 'btree', columns: [
        'gateId',
      ] },
    ],
    constraints: [
      { name: 'gate_gate_id_key', constraint: 'unique', columns: ['gateId'] },
    ],
  }, GateRow),
  harness_score: __table({
    name: 'harness_score',
    indexes: [
      { accessor: 'score_id', name: 'harness_score_score_id_idx_btree', algorithm: 'btree', columns: [
        'scoreId',
      ] },
    ],
    constraints: [
      { name: 'harness_score_score_id_key', constraint: 'unique', columns: ['scoreId'] },
    ],
  }, HarnessScoreRow),
  ledger_entry_curated: __table({
    name: 'ledger_entry_curated',
    indexes: [
      { accessor: 'entry_id', name: 'ledger_entry_curated_entry_id_idx_btree', algorithm: 'btree', columns: [
        'entryId',
      ] },
    ],
    constraints: [
      { name: 'ledger_entry_curated_entry_id_key', constraint: 'unique', columns: ['entryId'] },
    ],
  }, LedgerEntryCuratedRow),
  message: __table({
    name: 'message',
    indexes: [
      { accessor: 'message_id', name: 'message_message_id_idx_btree', algorithm: 'btree', columns: [
        'messageId',
      ] },
    ],
    constraints: [
      { name: 'message_message_id_key', constraint: 'unique', columns: ['messageId'] },
    ],
  }, MessageRow),
  message_attachment: __table({
    name: 'message_attachment',
    indexes: [
      { accessor: 'attachment_id', name: 'message_attachment_attachment_id_idx_btree', algorithm: 'btree', columns: [
        'attachmentId',
      ] },
    ],
    constraints: [
      { name: 'message_attachment_attachment_id_key', constraint: 'unique', columns: ['attachmentId'] },
    ],
  }, MessageAttachmentRow),
  message_chunk: __table({
    name: 'message_chunk',
    indexes: [
      { accessor: 'chunk_id', name: 'message_chunk_chunk_id_idx_btree', algorithm: 'btree', columns: [
        'chunkId',
      ] },
    ],
    constraints: [
      { name: 'message_chunk_chunk_id_key', constraint: 'unique', columns: ['chunkId'] },
    ],
  }, MessageChunkRow),
  message_mention: __table({
    name: 'message_mention',
    indexes: [
      { accessor: 'mention_id', name: 'message_mention_mention_id_idx_btree', algorithm: 'btree', columns: [
        'mentionId',
      ] },
    ],
    constraints: [
      { name: 'message_mention_mention_id_key', constraint: 'unique', columns: ['mentionId'] },
    ],
  }, MessageMentionRow),
  message_status: __table({
    name: 'message_status',
    indexes: [
      { accessor: 'message_id', name: 'message_status_message_id_idx_btree', algorithm: 'btree', columns: [
        'messageId',
      ] },
    ],
    constraints: [
      { name: 'message_status_message_id_key', constraint: 'unique', columns: ['messageId'] },
    ],
  }, MessageStatusRow),
  model_release: __table({
    name: 'model_release',
    indexes: [
      { accessor: 'release_id', name: 'model_release_release_id_idx_btree', algorithm: 'btree', columns: [
        'releaseId',
      ] },
    ],
    constraints: [
      { name: 'model_release_release_id_key', constraint: 'unique', columns: ['releaseId'] },
    ],
  }, ModelReleaseRow),
  module_heartbeat: __table({
    name: 'module_heartbeat',
    indexes: [
      { accessor: 'id', name: 'module_heartbeat_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'module_heartbeat_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ModuleHeartbeatRow),
  news_item: __table({
    name: 'news_item',
    indexes: [
      { accessor: 'news_id', name: 'news_item_news_id_idx_btree', algorithm: 'btree', columns: [
        'newsId',
      ] },
    ],
    constraints: [
      { name: 'news_item_news_id_key', constraint: 'unique', columns: ['newsId'] },
    ],
  }, NewsItemRow),
  org: __table({
    name: 'org',
    indexes: [
      { accessor: 'org_id', name: 'org_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
      { accessor: 'slug', name: 'org_slug_idx_btree', algorithm: 'btree', columns: [
        'slug',
      ] },
    ],
    constraints: [
      { name: 'org_org_id_key', constraint: 'unique', columns: ['orgId'] },
      { name: 'org_slug_key', constraint: 'unique', columns: ['slug'] },
    ],
  }, OrgRow),
  org_invite: __table({
    name: 'org_invite',
    indexes: [
      { accessor: 'invite_id', name: 'org_invite_invite_id_idx_btree', algorithm: 'btree', columns: [
        'inviteId',
      ] },
    ],
    constraints: [
      { name: 'org_invite_invite_id_key', constraint: 'unique', columns: ['inviteId'] },
    ],
  }, OrgInviteRow),
  org_limits: __table({
    name: 'org_limits',
    indexes: [
      { accessor: 'org_id', name: 'org_limits_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
    ],
    constraints: [
      { name: 'org_limits_org_id_key', constraint: 'unique', columns: ['orgId'] },
    ],
  }, OrgLimitsRow),
  org_membership: __table({
    name: 'org_membership',
    indexes: [
      { accessor: 'membership_id', name: 'org_membership_membership_id_idx_btree', algorithm: 'btree', columns: [
        'membershipId',
      ] },
    ],
    constraints: [
      { name: 'org_membership_membership_id_key', constraint: 'unique', columns: ['membershipId'] },
    ],
  }, OrgMembershipRow),
  outcome_tag: __table({
    name: 'outcome_tag',
    indexes: [
      { accessor: 'tag_id', name: 'outcome_tag_tag_id_idx_btree', algorithm: 'btree', columns: [
        'tagId',
      ] },
    ],
    constraints: [
      { name: 'outcome_tag_tag_id_key', constraint: 'unique', columns: ['tagId'] },
    ],
  }, OutcomeTagRow),
  pending_commit: __table({
    name: 'pending_commit',
    indexes: [
      { accessor: 'pending_commit_id', name: 'pending_commit_pending_commit_id_idx_btree', algorithm: 'btree', columns: [
        'pendingCommitId',
      ] },
    ],
    constraints: [
      { name: 'pending_commit_pending_commit_id_key', constraint: 'unique', columns: ['pendingCommitId'] },
    ],
  }, PendingCommitRow),
  pending_route: __table({
    name: 'pending_route',
    indexes: [
      { accessor: 'route_id', name: 'pending_route_route_id_idx_btree', algorithm: 'btree', columns: [
        'routeId',
      ] },
    ],
    constraints: [
      { name: 'pending_route_route_id_key', constraint: 'unique', columns: ['routeId'] },
    ],
  }, PendingRouteRow),
  pending_turn: __table({
    name: 'pending_turn',
    indexes: [
      { accessor: 'turn_id', name: 'pending_turn_turn_id_idx_btree', algorithm: 'btree', columns: [
        'turnId',
      ] },
    ],
    constraints: [
      { name: 'pending_turn_turn_id_key', constraint: 'unique', columns: ['turnId'] },
    ],
  }, PendingTurnRow),
  persona_candidate: __table({
    name: 'persona_candidate',
    indexes: [
      { accessor: 'candidate_id', name: 'persona_candidate_candidate_id_idx_btree', algorithm: 'btree', columns: [
        'candidateId',
      ] },
    ],
    constraints: [
      { name: 'persona_candidate_candidate_id_key', constraint: 'unique', columns: ['candidateId'] },
    ],
  }, PersonaCandidateRow),
  persona_card_seed: __table({
    name: 'persona_card_seed',
    indexes: [
      { accessor: 'seed_id', name: 'persona_card_seed_seed_id_idx_btree', algorithm: 'btree', columns: [
        'seedId',
      ] },
    ],
    constraints: [
      { name: 'persona_card_seed_seed_id_key', constraint: 'unique', columns: ['seedId'] },
    ],
  }, PersonaCardSeedRow),
  persona_contract: __table({
    name: 'persona_contract',
    indexes: [
      { accessor: 'agent_id', name: 'persona_contract_agent_id_idx_btree', algorithm: 'btree', columns: [
        'agentId',
      ] },
    ],
    constraints: [
      { name: 'persona_contract_agent_id_key', constraint: 'unique', columns: ['agentId'] },
    ],
  }, PersonaContractRow),
  persona_score_rollup: __table({
    name: 'persona_score_rollup',
    indexes: [
      { accessor: 'id', name: 'persona_score_rollup_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'persona_score_rollup_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, PersonaScoreRollupRow),
  provider_key: __table({
    name: 'provider_key',
    indexes: [
      { accessor: 'id', name: 'provider_key_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'provider_key_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ProviderKeyRow),
  receipt: __table({
    name: 'receipt',
    indexes: [
      { accessor: 'receipt_id', name: 'receipt_receipt_id_idx_btree', algorithm: 'btree', columns: [
        'receiptId',
      ] },
    ],
    constraints: [
      { name: 'receipt_receipt_id_key', constraint: 'unique', columns: ['receiptId'] },
    ],
  }, ReceiptRow),
  receipt_narration: __table({
    name: 'receipt_narration',
    indexes: [
      { accessor: 'narration_id', name: 'receipt_narration_narration_id_idx_btree', algorithm: 'btree', columns: [
        'narrationId',
      ] },
    ],
    constraints: [
      { name: 'receipt_narration_narration_id_key', constraint: 'unique', columns: ['narrationId'] },
    ],
  }, ReceiptNarrationRow),
  recipe_scorecard: __table({
    name: 'recipe_scorecard',
    indexes: [
      { accessor: 'scorecard_id', name: 'recipe_scorecard_scorecard_id_idx_btree', algorithm: 'btree', columns: [
        'scorecardId',
      ] },
    ],
    constraints: [
      { name: 'recipe_scorecard_scorecard_id_key', constraint: 'unique', columns: ['scorecardId'] },
    ],
  }, RecipeScorecardRow),
  recipe_use: __table({
    name: 'recipe_use',
    indexes: [
      { accessor: 'use_id', name: 'recipe_use_use_id_idx_btree', algorithm: 'btree', columns: [
        'useId',
      ] },
    ],
    constraints: [
      { name: 'recipe_use_use_id_key', constraint: 'unique', columns: ['useId'] },
    ],
  }, RecipeUseRow),
  remote_env_usage: __table({
    name: 'remote_env_usage',
    indexes: [
      { accessor: 'usage_id', name: 'remote_env_usage_usage_id_idx_btree', algorithm: 'btree', columns: [
        'usageId',
      ] },
    ],
    constraints: [
      { name: 'remote_env_usage_usage_id_key', constraint: 'unique', columns: ['usageId'] },
    ],
  }, RemoteEnvUsageRow),
  repo_commit_author: __table({
    name: 'repo_commit_author',
    indexes: [
      { accessor: 'id', name: 'repo_commit_author_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'repo_commit_author_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, RepoCommitAuthorRow),
  repo_connection: __table({
    name: 'repo_connection',
    indexes: [
      { accessor: 'repo_connection_id', name: 'repo_connection_repo_connection_id_idx_btree', algorithm: 'btree', columns: [
        'repoConnectionId',
      ] },
    ],
    constraints: [
      { name: 'repo_connection_repo_connection_id_key', constraint: 'unique', columns: ['repoConnectionId'] },
    ],
  }, RepoConnectionRow),
  resend_usage: __table({
    name: 'resend_usage',
    indexes: [
      { accessor: 'usage_id', name: 'resend_usage_usage_id_idx_btree', algorithm: 'btree', columns: [
        'usageId',
      ] },
    ],
    constraints: [
      { name: 'resend_usage_usage_id_key', constraint: 'unique', columns: ['usageId'] },
    ],
  }, ResendUsageRow),
  road: __table({
    name: 'road',
    indexes: [
      { accessor: 'road_id', name: 'road_road_id_idx_btree', algorithm: 'btree', columns: [
        'roadId',
      ] },
    ],
    constraints: [
      { name: 'road_road_id_key', constraint: 'unique', columns: ['roadId'] },
    ],
  }, RoadRow),
  runner_session: __table({
    name: 'runner_session',
    indexes: [
      { accessor: 'session_id', name: 'runner_session_session_id_idx_btree', algorithm: 'btree', columns: [
        'sessionId',
      ] },
    ],
    constraints: [
      { name: 'runner_session_session_id_key', constraint: 'unique', columns: ['sessionId'] },
    ],
  }, RunnerSessionRow),
  score: __table({
    name: 'score',
    indexes: [
      { accessor: 'score_id', name: 'score_score_id_idx_btree', algorithm: 'btree', columns: [
        'scoreId',
      ] },
    ],
    constraints: [
      { name: 'score_score_id_key', constraint: 'unique', columns: ['scoreId'] },
    ],
  }, ScoreRow),
  shadow_run: __table({
    name: 'shadow_run',
    indexes: [
      { accessor: 'shadow_run_id', name: 'shadow_run_shadow_run_id_idx_btree', algorithm: 'btree', columns: [
        'shadowRunId',
      ] },
    ],
    constraints: [
      { name: 'shadow_run_shadow_run_id_key', constraint: 'unique', columns: ['shadowRunId'] },
    ],
  }, ShadowRunRow),
  step: __table({
    name: 'step',
    indexes: [
      { accessor: 'step_id', name: 'step_step_id_idx_btree', algorithm: 'btree', columns: [
        'stepId',
      ] },
    ],
    constraints: [
      { name: 'step_step_id_key', constraint: 'unique', columns: ['stepId'] },
    ],
  }, StepRow),
  stripe_event: __table({
    name: 'stripe_event',
    indexes: [
      { accessor: 'event_id', name: 'stripe_event_event_id_idx_btree', algorithm: 'btree', columns: [
        'eventId',
      ] },
    ],
    constraints: [
      { name: 'stripe_event_event_id_key', constraint: 'unique', columns: ['eventId'] },
    ],
  }, StripeEventRow),
  subscription: __table({
    name: 'subscription',
    indexes: [
      { accessor: 'id', name: 'subscription_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'subscription_id_key', constraint: 'unique', columns: ['id'] },
      { name: 'subscription_customer_id_key', constraint: 'unique', columns: ['customerId'] },
    ],
  }, SubscriptionRow),
  task_tag: __table({
    name: 'task_tag',
    indexes: [
      { accessor: 'tag_id', name: 'task_tag_tag_id_idx_btree', algorithm: 'btree', columns: [
        'tagId',
      ] },
    ],
    constraints: [
      { name: 'task_tag_tag_id_key', constraint: 'unique', columns: ['tagId'] },
    ],
  }, TaskTagRow),
  team_recipe: __table({
    name: 'team_recipe',
    indexes: [
      { accessor: 'recipe_id', name: 'team_recipe_recipe_id_idx_btree', algorithm: 'btree', columns: [
        'recipeId',
      ] },
    ],
    constraints: [
      { name: 'team_recipe_recipe_id_key', constraint: 'unique', columns: ['recipeId'] },
    ],
  }, TeamRecipeRow),
  team_recipe_seat: __table({
    name: 'team_recipe_seat',
    indexes: [
      { accessor: 'agent_id', name: 'team_recipe_seat_agent_id_idx_btree', algorithm: 'btree', columns: [
        'agentId',
      ] },
    ],
    constraints: [
      { name: 'team_recipe_seat_agent_id_key', constraint: 'unique', columns: ['agentId'] },
    ],
  }, TeamRecipeSeatRow),
  thread: __table({
    name: 'thread',
    indexes: [
      { accessor: 'thread_id', name: 'thread_thread_id_idx_btree', algorithm: 'btree', columns: [
        'threadId',
      ] },
    ],
    constraints: [
      { name: 'thread_thread_id_key', constraint: 'unique', columns: ['threadId'] },
    ],
  }, ThreadRow),
  thread_message: __table({
    name: 'thread_message',
    indexes: [
      { accessor: 'thread_message_id', name: 'thread_message_thread_message_id_idx_btree', algorithm: 'btree', columns: [
        'threadMessageId',
      ] },
    ],
    constraints: [
      { name: 'thread_message_thread_message_id_key', constraint: 'unique', columns: ['threadMessageId'] },
    ],
  }, ThreadMessageRow),
  thread_participant: __table({
    name: 'thread_participant',
    indexes: [
      { accessor: 'id', name: 'thread_participant_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'thread_participant_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ThreadParticipantRow),
  trace_point: __table({
    name: 'trace_point',
    indexes: [
      { accessor: 'trace_id', name: 'trace_point_trace_id_idx_btree', algorithm: 'btree', columns: [
        'traceId',
      ] },
    ],
    constraints: [
      { name: 'trace_point_trace_id_key', constraint: 'unique', columns: ['traceId'] },
    ],
  }, TracePointRow),
  turn_usage: __table({
    name: 'turn_usage',
    indexes: [
      { accessor: 'turn_id', name: 'turn_usage_turn_id_idx_btree', algorithm: 'btree', columns: [
        'turnId',
      ] },
    ],
    constraints: [
      { name: 'turn_usage_turn_id_key', constraint: 'unique', columns: ['turnId'] },
    ],
  }, TurnUsageRow),
  user_credential: __table({
    name: 'user_credential',
    indexes: [
      { accessor: 'email', name: 'user_credential_email_idx_btree', algorithm: 'btree', columns: [
        'email',
      ] },
      { accessor: 'identity', name: 'user_credential_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'user_credential_email_key', constraint: 'unique', columns: ['email'] },
      { name: 'user_credential_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, UserCredentialRow),
  user_profile: __table({
    name: 'user_profile',
    indexes: [
      { accessor: 'identity', name: 'user_profile_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'user_profile_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, UserProfileRow),
  user_role: __table({
    name: 'user_role',
    indexes: [
      { accessor: 'identity', name: 'user_role_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'user_role_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, UserRoleRow),
  user_score_rollup: __table({
    name: 'user_score_rollup',
    indexes: [
      { accessor: 'id', name: 'user_score_rollup_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'user_score_rollup_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, UserScoreRollupRow),
  watcher_fire: __table({
    name: 'watcher_fire',
    indexes: [
      { accessor: 'watcher_fire_id', name: 'watcher_fire_watcher_fire_id_idx_btree', algorithm: 'btree', columns: [
        'watcherFireId',
      ] },
    ],
    constraints: [
      { name: 'watcher_fire_watcher_fire_id_key', constraint: 'unique', columns: ['watcherFireId'] },
    ],
  }, WatcherFireRow),
  workspace: __table({
    name: 'workspace',
    indexes: [
      { accessor: 'workspace_id', name: 'workspace_workspace_id_idx_btree', algorithm: 'btree', columns: [
        'workspaceId',
      ] },
    ],
    constraints: [
      { name: 'workspace_workspace_id_key', constraint: 'unique', columns: ['workspaceId'] },
    ],
  }, WorkspaceRow),
  workspace_member: __table({
    name: 'workspace_member',
    indexes: [
      { accessor: 'id', name: 'workspace_member_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'workspace_member_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, WorkspaceMemberRow),
  workspace_memory: __table({
    name: 'workspace_memory',
    indexes: [
      { accessor: 'memory_id', name: 'workspace_memory_memory_id_idx_btree', algorithm: 'btree', columns: [
        'memoryId',
      ] },
    ],
    constraints: [
      { name: 'workspace_memory_memory_id_key', constraint: 'unique', columns: ['memoryId'] },
    ],
  }, WorkspaceMemoryRow),
  workspace_model_access: __table({
    name: 'workspace_model_access',
    indexes: [
      { accessor: 'access_id', name: 'workspace_model_access_access_id_idx_btree', algorithm: 'btree', columns: [
        'accessId',
      ] },
    ],
    constraints: [
      { name: 'workspace_model_access_access_id_key', constraint: 'unique', columns: ['accessId'] },
    ],
  }, WorkspaceModelAccessRow),
  workspace_provider_key: __table({
    name: 'workspace_provider_key',
    indexes: [
      { accessor: 'id', name: 'workspace_provider_key_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'workspace_provider_key_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, WorkspaceProviderKeyRow),
  workspace_tab: __table({
    name: 'workspace_tab',
    indexes: [
      { accessor: 'tab_id', name: 'workspace_tab_tab_id_idx_btree', algorithm: 'btree', columns: [
        'tabId',
      ] },
    ],
    constraints: [
      { name: 'workspace_tab_tab_id_key', constraint: 'unique', columns: ['tabId'] },
    ],
  }, WorkspaceTabRow),
});

/** The schema information for all reducers in this module. This is defined the same way as the reducers would have been defined in the server, except the body of the reducer is omitted in code generation. */
const reducersSchema = __reducers(
  __reducerSchema("admin_add_org_member", AdminAddOrgMemberReducer),
  __reducerSchema("admin_add_repo_connection", AdminAddRepoConnectionReducer),
  __reducerSchema("admin_add_retro_note", AdminAddRetroNoteReducer),
  __reducerSchema("admin_add_thread_participant", AdminAddThreadParticipantReducer),
  __reducerSchema("admin_add_workspace_member", AdminAddWorkspaceMemberReducer),
  __reducerSchema("admin_append_agent_message_chunk", AdminAppendAgentMessageChunkReducer),
  __reducerSchema("admin_attach_message_evidence", AdminAttachMessageEvidenceReducer),
  __reducerSchema("admin_attach_outcome_tag", AdminAttachOutcomeTagReducer),
  __reducerSchema("admin_attach_receipt_narration", AdminAttachReceiptNarrationReducer),
  __reducerSchema("admin_attach_task_tag", AdminAttachTaskTagReducer),
  __reducerSchema("admin_close_runner_session", AdminCloseRunnerSessionReducer),
  __reducerSchema("admin_close_workspace_tab", AdminCloseWorkspaceTabReducer),
  __reducerSchema("admin_complete_agent_message", AdminCompleteAgentMessageReducer),
  __reducerSchema("admin_complete_pending_route", AdminCompletePendingRouteReducer),
  __reducerSchema("admin_complete_pending_turn", AdminCompletePendingTurnReducer),
  __reducerSchema("admin_create_agenda", AdminCreateAgendaReducer),
  __reducerSchema("admin_create_gate", AdminCreateGateReducer),
  __reducerSchema("admin_create_org", AdminCreateOrgReducer),
  __reducerSchema("admin_create_org_invite", AdminCreateOrgInviteReducer),
  __reducerSchema("admin_create_pending_commit", AdminCreatePendingCommitReducer),
  __reducerSchema("admin_create_persona_candidate", AdminCreatePersonaCandidateReducer),
  __reducerSchema("admin_create_receipt", AdminCreateReceiptReducer),
  __reducerSchema("admin_create_road", AdminCreateRoadReducer),
  __reducerSchema("admin_create_shadow_run", AdminCreateShadowRunReducer),
  __reducerSchema("admin_create_step", AdminCreateStepReducer),
  __reducerSchema("admin_create_team_recipe", AdminCreateTeamRecipeReducer),
  __reducerSchema("admin_create_thread", AdminCreateThreadReducer),
  __reducerSchema("admin_create_user_agent", AdminCreateUserAgentReducer),
  __reducerSchema("admin_create_user_watcher", AdminCreateUserWatcherReducer),
  __reducerSchema("admin_create_workspace", AdminCreateWorkspaceReducer),
  __reducerSchema("admin_delete_agenda", AdminDeleteAgendaReducer),
  __reducerSchema("admin_delete_message", AdminDeleteMessageReducer),
  __reducerSchema("admin_delete_persona_candidate", AdminDeletePersonaCandidateReducer),
  __reducerSchema("admin_delete_persona_contract", AdminDeletePersonaContractReducer),
  __reducerSchema("admin_delete_road", AdminDeleteRoadReducer),
  __reducerSchema("admin_delete_step", AdminDeleteStepReducer),
  __reducerSchema("admin_delete_team_recipe", AdminDeleteTeamRecipeReducer),
  __reducerSchema("admin_delete_user_agent", AdminDeleteUserAgentReducer),
  __reducerSchema("admin_delete_workspace", AdminDeleteWorkspaceReducer),
  __reducerSchema("admin_ensure_user_personal_org", AdminEnsureUserPersonalOrgReducer),
  __reducerSchema("admin_fail_pending_turn", AdminFailPendingTurnReducer),
  __reducerSchema("admin_fork_team_recipe", AdminForkTeamRecipeReducer),
  __reducerSchema("admin_insert_follow_up_route", AdminInsertFollowUpRouteReducer),
  __reducerSchema("admin_lock_pending_route", AdminLockPendingRouteReducer),
  __reducerSchema("admin_lock_pending_turn", AdminLockPendingTurnReducer),
  __reducerSchema("admin_mark_model_release_queued", AdminMarkModelReleaseQueuedReducer),
  __reducerSchema("admin_mark_org_invite_accepted", AdminMarkOrgInviteAcceptedReducer),
  __reducerSchema("admin_open_runner_session", AdminOpenRunnerSessionReducer),
  __reducerSchema("admin_open_workspace_tab", AdminOpenWorkspaceTabReducer),
  __reducerSchema("admin_post_agent_message", AdminPostAgentMessageReducer),
  __reducerSchema("admin_post_message", AdminPostMessageReducer),
  __reducerSchema("admin_post_system_message", AdminPostSystemMessageReducer),
  __reducerSchema("admin_post_thread_message", AdminPostThreadMessageReducer),
  __reducerSchema("admin_publish_persona_card_seed", AdminPublishPersonaCardSeedReducer),
  __reducerSchema("admin_record_chat_usage", AdminRecordChatUsageReducer),
  __reducerSchema("admin_record_curated_entry", AdminRecordCuratedEntryReducer),
  __reducerSchema("admin_record_decision", AdminRecordDecisionReducer),
  __reducerSchema("admin_record_digest_sent", AdminRecordDigestSentReducer),
  __reducerSchema("admin_record_drift_alert", AdminRecordDriftAlertReducer),
  __reducerSchema("admin_record_finding", AdminRecordFindingReducer),
  __reducerSchema("admin_record_model_release", AdminRecordModelReleaseReducer),
  __reducerSchema("admin_record_news_item", AdminRecordNewsItemReducer),
  __reducerSchema("admin_record_recipe_use", AdminRecordRecipeUseReducer),
  __reducerSchema("admin_record_remote_env_usage", AdminRecordRemoteEnvUsageReducer),
  __reducerSchema("admin_record_resend_usage", AdminRecordResendUsageReducer),
  __reducerSchema("admin_record_score", AdminRecordScoreReducer),
  __reducerSchema("admin_record_trace_point", AdminRecordTracePointReducer),
  __reducerSchema("admin_record_turn_usage", AdminRecordTurnUsageReducer),
  __reducerSchema("admin_record_watcher_fire", AdminRecordWatcherFireReducer),
  __reducerSchema("admin_record_workspace_heartbeat", AdminRecordWorkspaceHeartbeatReducer),
  __reducerSchema("admin_register_user", AdminRegisterUserReducer),
  __reducerSchema("admin_remove_repo_connection", AdminRemoveRepoConnectionReducer),
  __reducerSchema("admin_remove_workspace_member", AdminRemoveWorkspaceMemberReducer),
  __reducerSchema("admin_rename_org", AdminRenameOrgReducer),
  __reducerSchema("admin_rename_road", AdminRenameRoadReducer),
  __reducerSchema("admin_rename_workspace", AdminRenameWorkspaceReducer),
  __reducerSchema("admin_resolve_drift_alert", AdminResolveDriftAlertReducer),
  __reducerSchema("admin_revoke_cicd_webhook_secret", AdminRevokeCicdWebhookSecretReducer),
  __reducerSchema("admin_revoke_provider_key", AdminRevokeProviderKeyReducer),
  __reducerSchema("admin_revoke_workspace_provider_key", AdminRevokeWorkspaceProviderKeyReducer),
  __reducerSchema("admin_route_to_seat", AdminRouteToSeatReducer),
  __reducerSchema("admin_runner_heartbeat", AdminRunnerHeartbeatReducer),
  __reducerSchema("admin_seed_starter_recipes", AdminSeedStarterRecipesReducer),
  __reducerSchema("admin_seed_workspace_vela", AdminSeedWorkspaceVelaReducer),
  __reducerSchema("admin_set_agent_avatar_url", AdminSetAgentAvatarUrlReducer),
  __reducerSchema("admin_set_agent_model", AdminSetAgentModelReducer),
  __reducerSchema("admin_set_agent_muted", AdminSetAgentMutedReducer),
  __reducerSchema("admin_set_agent_status", AdminSetAgentStatusReducer),
  __reducerSchema("admin_set_agent_trigger", AdminSetAgentTriggerReducer),
  __reducerSchema("admin_set_cicd_webhook_secret", AdminSetCicdWebhookSecretReducer),
  __reducerSchema("admin_set_gate_status", AdminSetGateStatusReducer),
  __reducerSchema("admin_set_org_limits", AdminSetOrgLimitsReducer),
  __reducerSchema("admin_set_pending_commit_status", AdminSetPendingCommitStatusReducer),
  __reducerSchema("admin_set_provider_key", AdminSetProviderKeyReducer),
  __reducerSchema("admin_set_repo_commit_author", AdminSetRepoCommitAuthorReducer),
  __reducerSchema("admin_set_step_order", AdminSetStepOrderReducer),
  __reducerSchema("admin_set_step_status", AdminSetStepStatusReducer),
  __reducerSchema("admin_set_user_role", AdminSetUserRoleReducer),
  __reducerSchema("admin_set_workspace_autonomy", AdminSetWorkspaceAutonomyReducer),
  __reducerSchema("admin_set_workspace_digest_hour", AdminSetWorkspaceDigestHourReducer),
  __reducerSchema("admin_set_workspace_escalation_email", AdminSetWorkspaceEscalationEmailReducer),
  __reducerSchema("admin_set_workspace_model_access", AdminSetWorkspaceModelAccessReducer),
  __reducerSchema("admin_set_workspace_provider_key", AdminSetWorkspaceProviderKeyReducer),
  __reducerSchema("admin_set_workspace_sandbox", AdminSetWorkspaceSandboxReducer),
  __reducerSchema("admin_supersede_decision", AdminSupersedeDecisionReducer),
  __reducerSchema("admin_supersede_receipt", AdminSupersedeReceiptReducer),
  __reducerSchema("admin_update_shadow_run_status", AdminUpdateShadowRunStatusReducer),
  __reducerSchema("admin_upsert_cicd_result", AdminUpsertCicdResultReducer),
  __reducerSchema("admin_upsert_harness_score", AdminUpsertHarnessScoreReducer),
  __reducerSchema("admin_upsert_persona_contract", AdminUpsertPersonaContractReducer),
  __reducerSchema("admin_upsert_persona_score_rollup", AdminUpsertPersonaScoreRollupReducer),
  __reducerSchema("admin_upsert_recipe_scorecard", AdminUpsertRecipeScorecardReducer),
  __reducerSchema("admin_upsert_user_score_rollup", AdminUpsertUserScoreRollupReducer),
  __reducerSchema("admin_write_workspace_memory", AdminWriteWorkspaceMemoryReducer),
  __reducerSchema("bootstrap_admin", BootstrapAdminReducer),
);

/** The schema information for all procedures in this module. This is defined the same way as the procedures would have been defined in the server. */
const proceduresSchema = __procedures(
);

/** The remote SpacetimeDB module schema, both runtime and type information. */
const REMOTE_MODULE = {
  versionInfo: {
    cliVersion: "2.1.0" as const,
  },
  tables: tablesSchema.schemaType.tables,
  reducers: reducersSchema.reducersType.reducers,
  ...proceduresSchema,
} satisfies __RemoteModule<
  typeof tablesSchema.schemaType,
  typeof reducersSchema.reducersType,
  typeof proceduresSchema
>;

/** The tables available in this remote SpacetimeDB module. Each table reference doubles as a query builder. */
export const tables: __QueryBuilder<typeof tablesSchema.schemaType> = __makeQueryBuilder(tablesSchema.schemaType);

/** The reducers available in this remote SpacetimeDB module. */
export const reducers = __convertToAccessorMap(reducersSchema.reducersType.reducers);

/** The context type returned in callbacks for all possible events. */
export type EventContext = __EventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for reducer events. */
export type ReducerEventContext = __ReducerEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for subscription events. */
export type SubscriptionEventContext = __SubscriptionEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for error events. */
export type ErrorContext = __ErrorContextInterface<typeof REMOTE_MODULE>;
/** The subscription handle type to manage active subscriptions created from a {@link SubscriptionBuilder}. */
export type SubscriptionHandle = __SubscriptionHandleImpl<typeof REMOTE_MODULE>;

/** Builder class to configure a new subscription to the remote SpacetimeDB instance. */
export class SubscriptionBuilder extends __SubscriptionBuilderImpl<typeof REMOTE_MODULE> {}

/** Builder class to configure a new database connection to the remote SpacetimeDB instance. */
export class DbConnectionBuilder extends __DbConnectionBuilder<DbConnection> {}

/** The typed database connection to manage connections to the remote SpacetimeDB instance. This class has type information specific to the generated module. */
export class DbConnection extends __DbConnectionImpl<typeof REMOTE_MODULE> {
  /** Creates a new {@link DbConnectionBuilder} to configure and connect to the remote SpacetimeDB instance. */
  static builder = (): DbConnectionBuilder => {
    return new DbConnectionBuilder(REMOTE_MODULE, (config: __DbConnectionConfig<typeof REMOTE_MODULE>) => new DbConnection(config));
  };

  /** Creates a new {@link SubscriptionBuilder} to configure a subscription to the remote SpacetimeDB instance. */
  override subscriptionBuilder = (): SubscriptionBuilder => {
    return new SubscriptionBuilder(this);
  };
}

